import React from "react";
import {
  Typography,
  Paper,
  makeStyles,
  TextField,
  Button,
  Grid,
  IconButton,
  Divider,
  Box,
} from "@material-ui/core";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import MapIcon from "@material-ui/icons/Map";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4),
    background: theme.palette.type === "dark" ? "#000" : "#f5f5f5",
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: "2.2rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.type === "dark" ? "#fff" : "#000",
  },
  subtitle: {
    fontSize: "1.2rem",
    marginBottom: theme.spacing(2),
    textAlign: "center",
  },
  address: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginBottom: theme.spacing(2),
  },
  addressItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(1),
    color: "#8601af",
  },
  form: {
    marginTop: theme.spacing(2),
  },
  textField: {
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
    backgroundColor: "#8601af",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#8601af",
    },
  },
  divider: {
    margin: theme.spacing(4, 0),
  },
  mapButton: {
    color: "#e91e63",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

const Contact = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.container} elevation={3}>
      <Typography variant="h4" className={classes.title}>
        Get in Touch with Us
      </Typography>
      <Typography variant="h6" className={classes.subtitle}>
        We're here to help and answer any question you might have.
      </Typography>
      <Divider className={classes.divider} />
      <Grid container spacing={4}>
        <Grid item xs={12} md={6} className={classes.address}>
          <div className={classes.addressItem}>
            <LocationOnIcon className={classes.icon} />
            <Typography variant="body1">
              23A 10th avenue, Rivonia Sandton
            </Typography>
          </div>
          <div className={classes.addressItem}>
            <EmailIcon className={classes.icon} />
            <Typography variant="body1">ngembalenhle@gmail.com</Typography>
          </div>
          <div className={classes.addressItem}>
            <PhoneIcon className={classes.icon} />
            <Typography variant="body1">0677505304</Typography>
          </div>
          <Box className={classes.mapButton}>
            <MapIcon className={classes.icon} />
            <a
              href="https://goo.gl/maps/your-location-link"
              target="_blank"
              rel="noreferrer"
            >
              View on Map
            </a>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <form className={classes.form}>
            <TextField
              label="Name"
              variant="outlined"
              fullWidth
              className={classes.textField}
            />
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              className={classes.textField}
            />
            <TextField
              label="Message"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              className={classes.textField}
            />
            <Button variant="contained" className={classes.button} fullWidth>
              Send Message
            </Button>
          </form>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Contact;
